import React from 'react';

import PageNotFound from './PageNotFound';

const ConfigAutoRenew = () => <PageNotFound />;

export default ConfigAutoRenew;
